import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table as MuiTable, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Typography } from '@mui/material';
import { TableContainerDiv } from './styles';
import { COLORS } from '../../styles/constants';
import { setTableData } from '../../redux/modelDataSlice';
import { useEffect } from 'react';
import api from '../../api';
import ReactHtmlParser from 'react-html-parser';
import { TABLE_DATA_SOURCE } from '../../pageDefinition/constants/definitionConstants';

const Table = () => {
	const [maxColumnsPerTable, setMaxColumnsPerTable] = useState(getMaxColumnsPerTable());
	const defaultMappingName = useSelector(state => state.designDefinition.partDefinition.defaultMappingName);
	const tableDefinition = useSelector(state => state.designDefinition.partDefinition.table);
	const tableData = useSelector(state => state.modelData.tableData);
	const dispatch = useDispatch();
	const columnDefinition = tableDefinition.data;
	const columnWidth = 100 / maxColumnsPerTable + '%';

	function getMaxColumnsPerTable() {
		const screenWidth = window.innerWidth;
		if (screenWidth > 1200) {
			return 12;
		} else if (screenWidth > 800) {
			return 6;
		} else {
			return 3;
		}
	}

	useEffect(() => {
		function handleResize() {
			setMaxColumnsPerTable(getMaxColumnsPerTable());
		}
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		const createTableDataRequestForWD = () => {
			let wdTableParameters = [];
			columnDefinition.forEach(column => {
				if (column.dataSource === TABLE_DATA_SOURCE.WD) {
					wdTableParameters.push({
						mappingName: column.mappingName,
						unitPrefix: column.unitPrefix.mappingName
					});
				}
			});
			return {
				opn: defaultMappingName,
				parameters: wdTableParameters
			};
		};

		const createTableDataRequestForPRT = () => {
			let prtTableParameters = [];
			columnDefinition.forEach(column => {
				if (column.dataSource === TABLE_DATA_SOURCE.PRT) {
					prtTableParameters.push(column.mappingName);
				}
			});
			return {
				opn: defaultMappingName,
				taxonomy: tableDefinition.prtDataTaxonomy,
				mappingName: prtTableParameters
			};
		};

		const parseIfString = data => (typeof data === 'string' && data ? JSON.parse(data) : data);

		const fetchData = async () => {
			try {
				const wdRequest = createTableDataRequestForWD();
				const hasWdParams = wdRequest.parameters.length > 0;

				let prtTableDataPromise = api.gainParametersForTableFromPRT(createTableDataRequestForPRT());
				let wdTableDataPromise = hasWdParams ? api.gainParametersForTableFromWD(wdRequest) : Promise.resolve(null);

				let [prtTableDataRaw, wdTableDataRaw] = await Promise.all([prtTableDataPromise, wdTableDataPromise]);
				let prtTableData = parseIfString(prtTableDataRaw);
				let wdTableData = parseIfString(wdTableDataRaw);
				let result = { ...prtTableData, ...wdTableData };

				if (wdTableData) {
					columnDefinition.forEach(column => {
						if (column.dataSource === TABLE_DATA_SOURCE.WD && result[column.mappingName] && column.heading) {
							result[column.mappingName].heading =
								column.heading +
								(column.baseUnit
									? ' [' + (column.unitPrefix.prefix ? column.unitPrefix.prefix : '') + column.baseUnit + ']'
									: '');
						}
					});
				}

				dispatch(setTableData(result));
			} catch (err) {
				console.error(err);
			}
		};
		fetchData();
	}, [dispatch, defaultMappingName, columnDefinition, tableDefinition.prtDataTaxonomy]);

	const splitToTables = (inputArray, numberOfParts) => {
		let array = [...inputArray];
		let result = [];
		for (let i = numberOfParts; i > 0; i--) {
			result.push(array.splice(0, Math.ceil(array.length / i)));
		}
		return result;
	};

	const tables = splitToTables([...columnDefinition], Math.ceil(columnDefinition.length / maxColumnsPerTable));

	return (
		<TableContainerDiv>
			<Typography variant="subtitle2" component="h6">
				{tableDefinition.heading}:
			</Typography>
			{tables.map((tableColumns, tableIndex) => (
				<React.Fragment key={tableIndex}>
					<TableContainer component={Paper} sx={{ my: 2 }}>
						<MuiTable>
							<TableHead>
								<TableRow>
									{tableColumns.map((column, index) => (
										<TableCell
											key={index}
											style={{
												border: `1px solid ${COLORS.PRIMARY}`,
												width: columnWidth,
												padding: 0,
												fontSize: '12px',
												fontWeight: 600,
												textAlign: 'center'
											}}>
											{tableData
												? tableData[column.mappingName] && tableData[column.mappingName].heading
													? ReactHtmlParser(tableData[column.mappingName].heading)
													: '-'
												: null}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									{tableColumns.map((column, index) => (
										<TableCell
											key={index}
											style={{
												border: `1px solid ${COLORS.PRIMARY}`,
												width: columnWidth,
												height: '20px',
												padding: 0,
												fontSize: '11px',
												fontWeight: 600,
												textAlign: 'center'
											}}>
											{tableData
												? tableData[column.mappingName] &&
												  tableData[column.mappingName].value != null &&
												  tableData[column.mappingName].value !== 'null'
													? tableData[column.mappingName].value
													: '-'
												: null}
										</TableCell>
									))}
								</TableRow>
							</TableBody>
						</MuiTable>
					</TableContainer>
				</React.Fragment>
			))}
		</TableContainerDiv>
	);
};

export default Table;
